import { OnDestroy, Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

import { DataTableController } from "./controller.interface";

import { FlowDataTableComponent } from "../flow-data-table.component";

@Injectable()
export class WellTransferController implements DataTableController<any>, OnDestroy {
    
    component: FlowDataTableComponent;
    subscription: Subscription;

    constructor(
    ) {
    }

    onInit() {        
        this.subscription = this.component.table.onRendererInteraction.pipe(tap()).subscribe((result: { rendererType: string, row: any, colHeader: string }) => {
            if (result.rendererType === 'details') {                
                const builtUrl = `/dashboard/view/well/${result.row.id}`; 
                window.open(builtUrl);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

    objectEquals(obj1: any, obj2: any): boolean {
        return obj1.id === obj2.id;
    }
}
